module.exports = __webpack_public_path__ + "img/time-intro-h5.9a34eed4.png";